<template>
  <div>
    <div class="container">
      <div class="row justify-content-between">
        <div class="px-2">
          <el-form
            ref="queryForm"
            :model="queryForm"
            label-width="100px"
            :inline="true"
            @keyup.enter.native="handleQueryClick(queryForm)"  @submit.native.prevent
          >
            <el-form-item label="關鍵字" label-width="60px">
              <el-input
                v-model="queryForm.qstr"
                placeholder="帳號、名稱"
                size="small"
                style="width:130px"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                @click="handleQueryClick(queryForm)"
                size="small"
                >查詢</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="funcpanel">
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="addNewOrg"
            size="small"
            >新增{{ orgTitle }}使用者</el-button
          >
        </div>
      </div>
    </div>

    <CCard>
      <CCardHeader>
        <CIcon name="cil-library-building" /> 單位：{{ myownOrg }}
      </CCardHeader>
      <CCardBody>
        <CRow>
          <el-table
          :border="true"
            :data="users"
            @sort-change="sortChange"
            :default-sort="{ prop: 'id', order: 'ascending' }"
            stripe
            style="width: 100%"
          >
            <el-table-column
              prop="id"
              type="index"
              :index="indexFormatter"
              fixed
            >
            </el-table-column>

            <el-table-column
              label="帳號"
              prop="username"
              sortable="custom"
              width="150"
            >
            </el-table-column>

            <el-table-column
              label="名稱"
              prop="name"
              sortable="custom"
              width="170"
            >
            </el-table-column>

            <el-table-column width="230">
              <template #default="scope">
                <el-switch
                  :value="isAdminUser(scope.row.roles)"
                  :active-text="adminTitle"
                  disabled
                >
                </el-switch>
              </template>
            </el-table-column>

            <el-table-column label="操作">
              <template #default="scope">
                <el-button size="mini" @click="editUser(scope.row.id)"
                  >編輯
                </el-button>
                <el-button
                  type="danger"
                  size="mini"
                  @click="deleteUser(scope.row.id)"
                  :disabled="myUserId === scope.row.id"
                  v-if="myUserId !== scope.row.id"
                  >刪除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </CRow>

        <CRow>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </CRow>
        <AddEdtUserDlg
          v-model="addEdtUserDlgVisible"
          :userId="dlgUserId"
          :key="dlgKey"
        ></AddEdtUserDlg>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SYS_ORG_NAME, SYS_ADMIN_ROLE, ORG_ADMIN_ROLE } from "@/appConfig";
import AddEdtUserDlg from "@/components/AddEdtUserDlg";
export default {
  name: "userList",
  components: {
    AddEdtUserDlg,
  },
  created() {
    this.$store.dispatch(
      "user/list",
      {
        max: this.pageSize,
        offset: this.offset,
        sort: this.sort,
        order: this.order,
      },
      {
        root: true,
      }
    );
  },
  data() {
    return {
      dlgUserId: null,
      dlgKey: 0,
      addEdtUserDlgVisible: false,
      pageSize: 50,
      currentPage: 1,
      queryForm: {
        qstr: "",
      },
    };
  },
  methods: {
    isAdminUser(roles) {
      const adminRole = this.isMyownOrgSys ? SYS_ADMIN_ROLE : ORG_ADMIN_ROLE;
      return roles.includes(adminRole);
    },
    handleQueryClick(queryForm) {
      this.currentPage = 1; //reset pagination to the first page
      this.query(this.pageSize, 0, this.sort, this.order, queryForm);
    },
    addNewOrg() {
      this.addEdtUserDlgVisible = true;
      this.dlgUserId = null;
      this.dlgKey = this.dlgKey ? 0 : 1;
    },
    editUser(id) {
      /*console.log(`editUser: id = ${id}`);*/
      this.dlgUserId = id;
      this.dlgKey = this.dlgKey ? 0 : 1;
      this.addEdtUserDlgVisible = true;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.query(val, this.offset, this.sort, this.order, this.queryForm);
    },
    handleCurrentChange(page) {
      this.query(
        this.pageSize,
        this.pageSize * (page - 1),
        this.sort,
        this.order,
        this.queryForm
      );
    },
    query(max, offset, sort, order, params = {}) {
      this.$store.dispatch("user/list", {
        max: max,
        offset: offset,
        sort,
        order,
        ...params,
      });
    },
    indexFormatter(index) {
      return `#${parseInt(this.offset) + index + 1}`;
    },
    deleteUser(id) {
      this.$confirm("此操作將永久刪除該使用者, 是否繼續?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("user/remove", id).then(() => {
            this.query(
              this.pageSize,
              this.offset,
              this.sort,
              this.order,
              this.queryForm
            );
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {
          /*this.$message({*/
          /*type: 'info',*/
          /*message: '已取消删除'*/
          /*});          */
        });
    },
    sortChange(args) {
      if (args.order === null) {
        this.$store.commit("user/SET_SORT", "id");
        this.$store.commit("user/SET_ORDER", "ascending");
      } else {
        this.$store.commit("user/SET_SORT", args.prop);
        this.$store.commit("user/SET_ORDER", args.order);
      }
      this.query(
        this.pageSize,
        this.offset,
        this.sort,
        this.order,
        this.queryForm
      );
    },
  },
  computed: {
    isMyownOrgSys() {
      return this.myownOrg === SYS_ORG_NAME;
    },
    orgTitle() {
      return this.isMyownOrgSys ? "系統" : "單位";
    },
    adminTitle() {
      return this.isMyownOrgSys ? "超級管理員" : "單位管理員";
    },
    ...mapGetters({
      myownOrg: "auth/orgName",
      myUserId: "auth/user_id",
      users: "user/users",
      total: "user/total",
      offset: "user/offset",
      sort: "user/sort",
      order: "user/order",
    }),
  },
};
</script>

<style></style>
